<template>
    <div class="web-box-all">
      <ext-header select_menu="9"></ext-header>

      <div class="web-home-main">

        <div class="web-order-box">
          <div class="web-order-left">
            <ext-nav></ext-nav>
          </div>
          <div class="web-order-right">

            <div class="web-order-title">
              <ul>
                <li :class="[class_id=='2' ? 'select' : '']" @click="get_class('2')">
                  <a>活动消息</a>
                  <i v-if="count_2>0">{{count_2}}</i>
                </li>
                <li :class="[class_id=='3' ? 'select' : '']" @click="get_class('3')">
                  <a>到货消息</a>
                  <i v-if="count_3>0">{{count_3}}</i>
                </li>
                <li :class="[class_id=='1' ? 'select' : '']" @click="get_class('1')">
                  <a>发货消息</a>
                  <i v-if="count_1>0">{{count_1}}</i>
                </li>
                <li :class="[class_id=='4' ? 'select' : '']" @click="get_class('4')">
                  <a>退货消息</a>
                  <i v-if="count_4>0">{{count_4}}</i>
                </li>
              </ul>
            </div>

            <div class="web-coupons-list">

              <h2>
                <a style="width:600px">描述</a>
                <a style="width:120px">时间</a>
                <a style="width:50px">状态</a>
              </h2>

              <ext-loading v-if="list_data.length==0" style="width:100%;" title="当前没有消息"></ext-loading>

              <div style="width:100%; height:auto; border-top: 1px solid #efefef;" v-for="(vo,index) in list_data" :key="index" @click="get_target_show(vo.id,vo.class_id,vo.target_no)">

                <p style="width:100%; color:#666666;" v-if="vo.read_state==1">
                  <a style="width:570px; height:auto;">{{vo.message}}</a>
                  <a style="width:150px">{{vo.ctime}}</a>
                  <a style="text-align: center;">已读</a>
                </p>
                <p style="width:100%; color:#333333; font-weight:bold" v-else>
                  <a style="width:570px; height:auto;">{{vo.message}}</a>
                  <a style="width:150px">{{vo.ctime}}</a>
                  <a style="text-align: center;">未读</a>
                </p>
              </div>

            </div>

          </div>
        </div>

      </div>

      <div class="web-home-line"></div>

      <ext-footer></ext-footer>

    </div>
  </template>
<script>
import ExtHeader from '@/components/header/index'
import ExtFooter from '@/components/footer/index'
import ExtNav from '@/components/leftnav/index'
import ExtLoading from '@/components/loading/index'

import {getUserId, ajax, Encrypt, Decrypt, webUrl} from '@/utils/extend'

export default {
  name: 'message',
  components: {
    'ext-header': ExtHeader,
    'ext-footer': ExtFooter,
    'ext-nav': ExtNav,
    'ext-loading': ExtLoading
  },
  data () {
    return {
      title: '优惠券',
      class_id: '2',
      list_data: [],
      count_1: 0,
      count_2: 0,
      count_3: 0,
      count_4: 0
    }
  },
  mounted () {
    this.load_data()
  },
  methods: {
    get_class (id) {
      this.class_id = id
      this.load_data()
    },
    load_data () {
      var that = this
      var classId = that.class_id

      ajax({
        url: '/store/user/user_message_list',
        method: 'post',
        data: {
          uid: getUserId(),
          class_id: classId
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.list_data = ret.data.list_data
        } else {
          that.list_data = []
        }
      })

      ajax({
        url: '/store/user/get_message_count',
        method: 'post',
        data: {
          uid: getUserId(),
          user_id: getUserId()
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.count_1 = ret.data.count_1
          that.count_2 = ret.data.count_2
          that.count_3 = ret.data.count_3
          that.count_4 = ret.data.count_4
        }
      })
    },
    get_target_show (id, classId, no) {
      var that = this

      setTimeout(function () {
        if (classId === '1') {
          that.$router.push({path: '/order/order_show', query: {v: Encrypt(no)}})
        } else if (classId === '2') {
        // 活动消息

        } else if (classId === '3') {
          that.$router.push({path: '/goods/goods_show', query: {v: Encrypt(no)}})
        } else if (classId === '4') {
          that.$router.push({path: '/order/return_order_show', query: {v: Encrypt(no)}})
        }
      }, 1000)

      ajax({
        url: '/store/user/set_read_message',
        method: 'post',
        data: {
          uid: getUserId(),
          message_id: id
        }
      }, function (ret) {
      })
    }
  }
}
</script>
  <style scoped>
  header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,center,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p{
      display:-moz-box;
      display: box;
      display: -webkit-box;
      font-family: "Noto Sans SC";
      display: inline-flex;
  }

  a { text-decoration:none; }
  input { box-sizing:border-box;outline:none;}
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {-webkit-appearance: none;}
  input[type='number'] {-moz-appearance: textfield;}

  .web-box-all { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
  .web-home-main { width:1000px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
  .web-home-line { width:100%; height:70px; }

  .web-order-box { width:100%; height:auto; flex-flow:row; align-content:flex-start; margin-top:20px;}
    .web-order-left { width:200px; height:auto; margin-right:15px; flex-wrap:wrap; align-content:flex-start;}

    .web-order-right { width:785px; height:auto; flex-wrap:wrap; align-content:flex-start;}

      .web-user-title { width:100%; height:40px;flex-flow:row; align-content:flex-start;}
        .web-user-title p { width:auto; height:40px; position: relative; padding:0px 20px; line-height:40px; font-size:14px; color:#333333;}
        .web-user-title p i { width:2px; height:20px; float: left; background: #d81e06; position: absolute; top:10px; left:10px;}

      .web-user-title { width:100%; height:40px; flex-flow:row; align-content:flex-start;}
        .web-user-title p { width:auto; height:40px; position: relative; padding:0px 20px; line-height:40px; font-size:14px; color:#333333;}
        .web-user-title p i { width:2px; height:20px; float: left; background: #d81e06; position: absolute; top:10px; left:10px;}

      .web-order-title { width:100%; height:50px; border-bottom: 1px solid #dfdfdf;}
        .web-order-title ul { width:600px; height:50px; list-style:none; margin:0px; padding:0px; flex-wrap:wrap; align-content:flex-start;}
        .web-order-title ul li { width:110px; height:50px; cursor: pointer; line-height: 50px; font-size:14px; text-align: center;justify-content:center; }
        .web-order-title ul li a { color:#333333;}
        .web-order-title ul li a:hover { color:#d81e06; font-weight: bold;}
        .web-order-title ul li.select { border-bottom: 2px solid #d81e06;}
        .web-order-title ul li i { width:auto; height:20px; line-height:20px; padding:0px 6px; background: #d81e06; border-radius: 45px; font-style: normal; color:#ffffff;}

    .web-coupons-list { width:100%; height: auto; margin-top:15px; border:1px solid #dfdfdf; flex-wrap:wrap; align-content:flex-start;}
      .web-coupons-list h2 { width:100%; height: 40px; flex-flow:row; margin:0px; padding:0px 15px; align-content:flex-start; background: #f5f8fa;}
      .web-coupons-list h2 a { width:100px; height:40px; line-height:40px; font-size:14px; color:#333333;}
      .web-coupons-list h2 a:hover { color:#333333;}
      .web-coupons-list p { width:100%; height: auto; cursor: pointer; flex-flow:row; margin:0px; padding:0px 15px; align-content:flex-start;}
      .web-coupons-list p a { width:auto; height:auto; line-height:20px; padding:10px 0px; font-size:14px; color:#333333;}
      .web-coupons-list p a:hover {color:#333333;}

  </style>
  <style>
    .page-item.active .page-link { border:1px solid #d81e06;background: #d81e06 !important; color:#ffffff !important;}
  </style>



// WEBPACK FOOTER //
// src/pages/store/message.vue